import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { SellerAccountModel } from "../models/SellerAccountModel"
import { SellerModel } from "../models/SellerModel"

interface AppContextType {
    seller: SellerModel | null;
    setSeller: React.Dispatch<React.SetStateAction<SellerModel | null>>;
    sellerAccount: SellerAccountModel | null;
    setSellerAccount: React.Dispatch<React.SetStateAction<SellerAccountModel | null>>;
    getAccountFullName: () => string;
    initialSessionChecked: boolean;
    setInitialSessionChecked: React.Dispatch<React.SetStateAction<boolean>>;
}

const AppContext = React.createContext<AppContextType | undefined>(undefined)

interface AppProviderProps {
    children: ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps) => {

    const [seller, setSeller] = useState<SellerModel | null>(null);
    const [sellerAccount, setSellerAccount] = useState<SellerAccountModel | null>(null);
    const [initialSessionChecked, setInitialSessionChecked] = useState(false);

    const getAccountFullName = () => {
        return `${sellerAccount?.firstname} ${sellerAccount?.lastname}`;
    }

    return (
        <AppContext.Provider value={{ seller, setSeller, sellerAccount, setSellerAccount, getAccountFullName, initialSessionChecked, setInitialSessionChecked }}>
            {children}
        </AppContext.Provider>
    );

}

export const useAppContext = (): AppContextType => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within AppProvider');
    }
    return context;
}
